import type { TaskDefinition } from "@gearbox-protocol/deploy-tools-shared";
import { api } from "api";
import type { FC, PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import { useAsync } from "react-use";

interface TaskDefinitionsCtx {
  taskDefinitions: TaskDefinition[];
  loading: boolean;
}

const TaskDefinitionsContext = createContext<TaskDefinitionsCtx>({
  taskDefinitions: [],
  loading: false,
});

export const TaskDefinitionsProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { value: taskDefinitions = [], loading } = useAsync(async () => {
    try {
      return await api.listTaskDefinitions();
    } catch {
      return [];
    }
  }, []);

  return (
    <TaskDefinitionsContext.Provider value={{ taskDefinitions, loading }}>
      {children}
    </TaskDefinitionsContext.Provider>
  );
};

export const useTaskDefinitions = () => useContext(TaskDefinitionsContext);
